document.addEventListener("DOMContentLoaded", () => {
  function replaceH2Text() {
    // Find the target element, fallback to document.body if .template-index doesn't exist
    const targetElement = document.querySelector('.template-index');
    
    if (!targetElement) {
      console.warn('No target element found for H2 text replacement');
      return;
    }
    
    // Use TreeWalker for efficient text node traversal
    const walker = document.createTreeWalker(
      targetElement,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          // Only process text nodes that contain "H2"
          return /\bH2\b/.test(node.textContent) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const textNodesToReplace = [];
    let node;
    
    // Collect all text nodes that need replacement
    while (node = walker.nextNode()) {
      textNodesToReplace.push(node);
    }
    
    // Replace text in collected nodes
    textNodesToReplace.forEach(textNode => {
      if (/\bH2\b/.test(textNode.textContent)) {
        const parent = textNode.parentNode;
        const newHTML = textNode.textContent.replace(/\bH2\b/g, "H<sub>2</sub>");
        
        // Create a temporary container to parse the HTML
        const temp = document.createElement('span');
        temp.innerHTML = newHTML;
        
        // Replace the text node with the parsed content
        while (temp.firstChild) {
          parent.insertBefore(temp.firstChild, textNode);
        }
        parent.removeChild(textNode);
      }
    });
  }

  replaceH2Text();

  function setDynamicHeaderHeight() {
    const header = document.querySelector('.header, header, .shopify-section-header, [data-header]');
    const body = document.querySelector('body');

    if (header && body) {
      const headerHeight = header.offsetHeight;
      body.style.setProperty('--header-height', headerHeight + 'px');
    }
  }

  setDynamicHeaderHeight();

  window.addEventListener('resize', setDynamicHeaderHeight);
});
